import { render, staticRenderFns } from "./Cartouche.vue?vue&type=template&id=d5b071ee"
import script from "./Cartouche.vue?vue&type=script&lang=js"
export * from "./Cartouche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports